import { createIcon } from './createIcon'

export const AlertIcon = createIcon({
  displayName: 'AlertIcon',
  viewBox: '0 0 16 15',
  path: [
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.585786 9.14279C-0.195262 8.36175 -0.195262 7.09542 0.585787 6.31437L6.31437 0.585786C7.09542 -0.195262 8.36175 -0.195262 9.14279 0.585787L14.8714 6.31437C15.6524 7.09542 15.6524 8.36175 14.8714 9.14279L9.14279 14.8714C8.36175 15.6524 7.09542 15.6524 6.31437 14.8714L0.585786 9.14279ZM7.2392 4.36707C7.2392 3.99577 7.5402 3.69477 7.9115 3.69477C8.2828 3.69477 8.5838 3.99577 8.5838 4.36707V9.07319C8.5838 9.44449 8.2828 9.74549 7.9115 9.74549C7.5402 9.74549 7.2392 9.44449 7.2392 9.07319V4.36707ZM7.91147 10.4177C7.54016 10.4177 7.23916 10.7187 7.23916 11.09C7.23916 11.4613 7.54016 11.7623 7.91147 11.7623C8.28277 11.7623 8.58377 11.4613 8.58377 11.09C8.58377 10.7187 8.28277 10.4177 7.91147 10.4177Z"
      fill="currentColor"
    />,
  ],
})
